export default __webpack_public_path__ + "static/media/5.dc5238d2.svg";